import { PortalTrackingEvents } from '@app/utils/tracking-events';
import { throwSentryError } from '@app/utils/sentry';

type TrackingParams = {
  leadPortalLink?: string;
  optionPortalLink?: string;
  frPortalLink?: string;
  authorized?: boolean;
  verificationRequired?: boolean;
};

class TrackingService {
  cb: (meta: unknown) => void;

  params: TrackingParams;

  init(cb: (meta: unknown) => void) {
    this.cb = cb;
  }

  patch(params: TrackingParams) {
    this.params = { ...this.params, ...params };
  }

  makeMeta(eventName: PortalTrackingEvents | string, tags = {}) {
    const meta = {};

    Object.assign(meta, { event_name: eventName });

    if (this.params.leadPortalLink) {
      Object.assign(meta, { lead_portal_link: this.params.leadPortalLink });
    }

    if (this.params.optionPortalLink) {
      Object.assign(meta, { option_portal_link: this.params.optionPortalLink });
    }

    if (this.params.frPortalLink) {
      Object.assign(meta, { flight_request_portal_link: this.params.frPortalLink });
    }

    tags = { ...tags };

    if (this.params.authorized) {
      Object.assign(tags, { logged_in: true });
    }

    if (this.params.verificationRequired) {
      Object.assign(tags, { verification_required: true });
    }

    if (Object.keys(tags).length) {
      Object.assign(meta, { tags: JSON.stringify(tags) });
    }

    return meta;
  }

  track(eventName: PortalTrackingEvents | string, tags = {}) {
    if (!eventName) return;

    if (!this.cb || typeof this.cb !== 'function') return;

    try {
      const meta = this.makeMeta(eventName, tags);
      this.cb(meta);
    } catch (error) {
      console.log(error);
      throwSentryError('track', error);
    }
  }
}

export const Tracking = new TrackingService();
